var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from "react";
import { useObserver } from "../hooks/useObserver";
import { getAllStyleRules } from "../utils/dom";
import { IFrame } from "./IFrame";
import { Style } from "./Styles";
/**
 * Used to wrap and isolate reflection from rest of document
 */
export function Frame(_a) {
    var { children, style } = _a, frameProps = __rest(_a, ["children", "style"]);
    return (React.createElement(IFrame, Object.assign({ frameBorder: "none", scrolling: "no", style: Object.assign({ border: "none" }, style) }, frameProps),
        React.createElement(FrameStyles, null),
        children));
}
/**
 * Styling used to keep the mirror frame in-sync with document
 */
export function FrameStyles() {
    return (React.createElement(React.Fragment, null,
        React.createElement(ResetStyle, null),
        React.createElement(DocumentStyle, null)));
}
/**
 * Copy of the current document style sheets to be used in framing
 */
function DocumentStyle() {
    const [rules, setRules] = React.useState(getAllStyleRules);
    const onUpdate = React.useCallback(function updateRules() {
        const newRules = getAllStyleRules();
        if (JSON.stringify(rules) === JSON.stringify(newRules))
            return;
        setRules(newRules);
    }, [rules]);
    useObserver({
        ObserverClass: MutationObserver,
        onUpdate,
        initOptions: {
            attributeFilter: ["class"],
            attributes: true,
            characterData: true,
            childList: true,
            subtree: true,
        },
        target: window.document,
    });
    return React.createElement(Style, { id: "parent-document-mirror-stylesheets", rules: rules });
}
/**
 * https://www.webfx.com/blog/web-design/should-you-reset-your-css
 */
function ResetStyle() {
    return (React.createElement(React.Fragment, null,
        React.createElement("link", { rel: "stylesheet", href: "https://necolas.github.io/normalize.css/8.0.1/normalize.css" }),
        React.createElement(Style, { id: "reset-frame", rules: ["html { overflow: hidden }"] })));
}
